import { render, staticRenderFns } from "./DEmpty.vue?vue&type=template&id=7f1f0670&scoped=true"
import script from "./DEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./DEmpty.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DEmpty.vue?vue&type=style&index=0&id=7f1f0670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f0670",
  null
  
)

export default component.exports